import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import './App.css';

const API_URL = 'https://smartcommandsaas-backend.onrender.com/api';

export default function App() {
    const [email, setEmail] = useState('');
    const [token, setToken] = useState(localStorage.getItem('token') || '');
    const [commands, setCommands] = useState([]);
    const [serverKey, setServerKey] = useState('');
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (token) localStorage.setItem('token', token);
    }, [token]);

    const login = async () => {
        try {
            const res = await axios.post(`${API_URL}/request-login`, { email });

            // Show the magic login link (for MVP)
            setMessage(`Login link (MVP only): ${res.data.loginUrl}`);
            console.log("Use this link to login:", res.data.loginUrl);

            // Optionally auto-redirect or copy link
        } catch (err) {
            console.error(err);
            setMessage('Login failed.');
        }
    };


    const handleAddCommand = () => {
        setCommands([...commands, { id: uuidv4(), name: '', permission: '', actions: [''] }]);
    };

    const handleCommandChange = (id, field, value) => {
        setCommands(commands.map(cmd => cmd.id === id ? { ...cmd, [field]: value } : cmd));
    };

    const handleActionChange = (id, index, value) => {
        setCommands(commands.map(cmd =>
            cmd.id === id
                ? { ...cmd, actions: cmd.actions.map((a, i) => i === index ? value : a) }
                : cmd
        ));
    };

    const handleAddAction = (id) => {
        setCommands(commands.map(cmd =>
            cmd.id === id ? { ...cmd, actions: [...cmd.actions, ''] } : cmd
        ));
    };

    const handleDeleteCommand = (id) => {
        setCommands(commands.filter(cmd => cmd.id !== id));
    };

    const saveConfig = async () => {
        if (!serverKey.trim()) {
            setMessage("Pull Key is required.");
            return;
        }

        const yaml = generateYAML(commands);
        try {
            await axios.post(`${API_URL}/config`, { key: serverKey, config: yaml }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setMessage('Config saved successfully.');
        } catch (err) {
            console.error(err.response?.data || err.message);
            setMessage('Save failed.');
        }
    };

    const generateYAML = (cmds) => {
        let yml = 'commands:\n';
        for (const cmd of cmds) {
            yml += `  ${cmd.name}:\n`;
            yml += `    permission: ${cmd.permission}\n`;
            yml += `    actions:\n`;
            for (const act of cmd.actions) {
                yml += `      - \"${act}\"\n`;
            }
        }
        return yml;
    };

    return (
        <div className="p-6 max-w-4xl mx-auto font-sans">
            <h1 className="text-2xl font-bold mb-4">SmartCommands Cloud</h1>

            {!token && (
                <div className="mb-4">
                    <input type="email" className="border p-2 mr-2" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter your email" />
                    <button onClick={login} className="bg-blue-600 text-white px-4 py-2 rounded">Login</button>
                </div>
            )}

            {token && (
                <>
                    <div className="mb-4">
                        <label className="font-semibold">Pull Key:</label>
                        <div className="input-container">
                            <input
                                type="text"
                                className="border ml-2 p-2 w-64"
                                value={serverKey}
                                onChange={e => setServerKey(e.target.value)}
                                placeholder="e.g., my-server-1"
                            />
                            <span className="tooltip">Use this key with the /smartcommands pull command</span>
                        </div>
                        <span className="ml-2 text-sm text-gray-500">Used with /smartcommands pull</span>
                    </div>

                    {commands.map((cmd, index) => (
                        <div key={cmd.id} className="border rounded p-4 mb-4 bg-gray-50">
                            <div className="flex gap-2 mb-2">
                                <input type="text" placeholder="Command name" className="border p-2 flex-1" value={cmd.name} onChange={e => handleCommandChange(cmd.id, 'name', e.target.value)} />
                                <input type="text" placeholder="Permission" className="border p-2 flex-1" value={cmd.permission} onChange={e => handleCommandChange(cmd.id, 'permission', e.target.value)} />
                                <button onClick={() => handleDeleteCommand(cmd.id)} className="text-red-600">Delete</button>
                            </div>
                            {cmd.actions.map((a, i) => (
                                <input key={i} type="text" placeholder="Action line" className="border p-2 w-full mb-1" value={a} onChange={e => handleActionChange(cmd.id, i, e.target.value)} />
                            ))}
                            <button onClick={() => handleAddAction(cmd.id)} className="mt-1 text-blue-500 text-sm">+ Add Action</button>
                        </div>
                    ))}

                    <button onClick={handleAddCommand} className="bg-gray-300 px-4 py-2 rounded">+ New Command</button>
                    <button onClick={saveConfig} className="ml-3 bg-green-600 text-white px-4 py-2 rounded">Save Config</button>
                </>
            )}

            {message && <p className="mt-4 text-sm text-gray-700">{message}</p>}
        </div>
    );
}
